import { render, staticRenderFns } from "./PatientResultsChartInterpretations.vue?vue&type=template&id=3c9aafe6&scoped=true&"
import script from "./PatientResultsChartInterpretations.vue?vue&type=script&lang=ts&"
export * from "./PatientResultsChartInterpretations.vue?vue&type=script&lang=ts&"
import style0 from "./PatientResultsChartInterpretations.vue?vue&type=style&index=0&id=3c9aafe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9aafe6",
  null
  
)

export default component.exports